import type { SpinnerProps as _SpinnerProps } from "@chakra-ui/react";
import { forwardRef, Spinner as _Spinner } from "@chakra-ui/react";

export interface SpinnerProps extends _SpinnerProps {}

export const Spinner = forwardRef<SpinnerProps, "div">(({ ...props }, ref) => (
    <_Spinner ref={ref} {...props} />
));
